import BasicLayout from '@/layouts/basic-layout'

const prefix = 'fin-settlement-doc-'
export default {
  path: '/financial-manage/fin-settlement-doc',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '结算单管理-承'},
      component: () => import('@/pages/financial-manage/fin-settlement-doc/index')
    },
    {
      path: 'detail-create',
      name: `${prefix}create`,
      auth: ['hidden'],
      meta: {title: '结算单申请新增-承'},
      component: () => import('@/pages/financial-manage/fin-settlement-doc/detail-create')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '结算单申请编辑-承'},
      component: () => import('@/pages/financial-manage/fin-settlement-doc/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '业主合同收付款情况详情-承'},
      component: () => import('@/pages/financial-manage/fin-settlement-doc/detail-view')
    }
  ]
}
